(async () => {
    const { Core } = await importModule('Core');

    /* TCC 2026-08-11: icons come from this theme's own assets, not from GitHub.

       ICONS_URL previously pointed at raw.githubusercontent.com, so every
       first-time visitor fetched each menu icon from a host that is not a CDN,
       gives no uptime guarantee for hotlinking, and rate-limits. Measured on the
       live site: 4 icons in use (star, house, clock-rotate-left, phone), each an
       external request, plus one 404 for a nonexistent "contact" icon.

       Those four are now vendored as assets/fa-<name>.svg, each keeping its
       CC BY 4.0 attribution comment inline.

       The base URL is derived from this module's own location via import.meta.url
       rather than hardcoded, so it follows the theme id automatically and needs no
       Liquid change. layout/theme.liquid loads this file as <script type="module">,
       so import.meta is available.

       GitHub is kept as a FALLBACK ONLY, so that picking an un-vendored icon in the
       theme editor still renders instead of silently vanishing. To remove that
       request too, vendor the icon as assets/fa-<name>.svg.

       Also fixes a bug in the original: ICONS_URL ended in "/" and the template
       literal added another, requesting ".../svgs/solid//name.svg". */
    const LOCAL_ICONS = new URL('.', import.meta.url).href;
    const FALLBACK_ICONS = 'https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/';
    const ICON_PREFIX = 'icon-';
    const CN_ICON = '#icon';

    customElements.define('load-icon', class extends Core {

        async render() {
            if (this.localIcon || await this._loadIcon()) {
                this._displayIcon() 
                this._setIconProps()
                return
            } 
            this._removeContainer();
        }

        async _loadIcon() {
            const sources = [
                `${LOCAL_ICONS}fa-${this.iconName}.svg`,
                `${FALLBACK_ICONS}${this.iconName}.svg`
            ];
            for (const url of sources) {
                try {
                    const res = await fetch(url);
                    if (!res.ok) continue;
                    const svg = await res.text();
                    this.localIcon = svg;
                    return svg;
                } catch (error) {
                    // try the next source
                }
            }
            console.error(`load-icon: "${this.iconName}" not found locally or upstream`);
            return null;
        }

        _displayIcon() {
            this.innerHTML = this.localIcon;
        }
        
        _setIconProps() {
            const $icon = this.querySelector('svg');
            $icon.classList.add(CN_ICON);
            $icon.style.setProperty('--size', this.getAttribute('size'));
        }

        _removeContainer() {
            this.remove();
        }

        get localIcon() {
            return localStorage.getItem(this.localIconName)
        }

        set localIcon(svg) {
            return localStorage.setItem(this.localIconName, svg)
        }
        
        get iconName() {
            return this.getAttribute('name')
        }

        get localIconName() {
            return `${ICON_PREFIX}${this.iconName}`
        }
    })
})();